export default class Popup_Content {

    constructor(container){

        if( typeof container === 'string' ) {
            container = document.querySelector(container);
        }

        this.container = container;
        this.inner = container.querySelector('.inner');
        this.image = container.querySelector('.image img');
        this.name = container.querySelector('.name');
        this.position = container.querySelector('.position');
        this.description = container.querySelector('.description');
        // this.phone = container.querySelector('.phone .v');
        // this.email = container.querySelector('.email .v');
        // this.qualifications = container.querySelector('.qualifications .lists');
        // this.qualifications_parent = container.querySelector('.qualifications');

        // close button
        container.querySelector('.close').addEventListener('click',()=>{
            this.close();
        })
    }

    open(item_data){
        this.container.style.display = '';

        this.render_data(item_data);
    
        document.body.popup_content = this;

        setTimeout(()=>{
            document.body.addEventListener('click', this.outside_click_close);
        }, 200);
    }
    
    close(){
        this.container.style.display = 'none';
        document.body.removeEventListener('click', this.outside_click_close);
    }
    
    render_data(item_data){
        this.image.src = item_data.image;
        this.position.textContent = item_data.position;
        this.name.textContent = item_data.name;
        let new_desctiption = item_data.description.replaceAll("||", "'");
        new_desctiption = new_desctiption.replaceAll("|r|n", "<br />");
        this.description.innerHTML = new_desctiption;
        // this.phone.innerHTML = '<a href="tel:' + item_data.phone + '">' + item_data.phone + '</a>' ;
        // this.email.innerHTML = '<a href="mailto:' + item_data.email + '">' + item_data.email + '</a>' ;
        
        // if(item_data.qualifications.length < 1 ){
        //     this.qualifications_parent.style.display= 'none';
        // }else{
        //     this.qualifications.innerHTML = ''; 
        //     this.qualifications_parent.style.display= 'block';
        //     for(let i = 0 ; i < item_data.qualifications.length ; i ++  ){ 
        //         this.qualifications.innerHTML += '<li class="list">' +  item_data.qualifications[i]  + '</li>';
        //     }
        // }
        
    }
    
    outside_click_close(e){
        if( e.target == document.body.popup_content.inner ) return;
        if( e.target.closest('.inner') ) return;
        document.body.popup_content.close();
    }

}